import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { CircularProgress, ListItemText } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import TickIcon from "@mui/icons-material/CheckCircle";
import CrossIcon from "@mui/icons-material/Cancel";
import ListItemSecondaryAction from "@mui/material/ListItemSecondaryAction";
import Typography from "@mui/material/Typography";
import { makeStyles } from "tss-react/mui";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { useFriendships } from "../../context-providers/friendships-provider";

const useStyles = makeStyles()((theme) => ({
  loading: {
    height: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  emptyText: {
    color: theme.palette.grey.A200,
    padding: "10px",
  },

  accept: {
    color: theme.palette.success.main,
  },

  reject: {
    color: theme.palette.error.main,
  },

  userName: {
    marginLeft: "10px",
  },
}));

export default function ReceivedInvitationList() {
  const { removeFriendship, acceptFriendship, receivedInvitations } =
    useFriendships();
  const { classes } = useStyles();

  if (!receivedInvitations) {
    return (
      <Box className={classes.loading}>
        <CircularProgress />
      </Box>
    );
  }

  if (!receivedInvitations) {
    return (
      <Box className={classes.loading}>
        <CircularProgress />
      </Box>
    );
  }

  if (!receivedInvitations.length) {
    return (
      <Typography className={classes.emptyText} variant="body1" align="center">
        You have no invitations
      </Typography>
    );
  }

  return (
    <>
      <List aria-label="invitations">
        {receivedInvitations.map((invite: any) => (
          <ListItem key={invite.id}>
            <Avatar
              alt={invite.username.toLocaleUpperCase()}
              src={invite.img || "#"}
            />
            <ListItemText className={classes.userName}>
              {invite.username}
            </ListItemText>
            <ListItemSecondaryAction>
              {/* <IconButton */}
              {/*    className={classes.reject} */}
              {/*    onClick={() => blockUser(invite.id)} */}
              {/*    aria-label="block-person" */}
              {/* > */}
              {/*    <CrossIcon /> */}
              {/* </IconButton> */}
              <IconButton
                className={classes.reject}
                onClick={() => removeFriendship(invite.id)}
                aria-label="reject-invite"
              >
                <CrossIcon />
              </IconButton>
              <IconButton
                className={classes.accept}
                onClick={() => acceptFriendship(invite.id)}
                aria-label="accept-invite"
              >
                <TickIcon />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
    </>
  );
}
